<template lang="pug">
  div.block-connector(:class="Boolean(buttonOnly) ? 'd-inline-block' : 'd-block'")
    b-button(
      v-if="Boolean(buttonOnly)",
      :variant="variant",
      :size="size",
      :class="pill ? 'pill' : ''",
      :id="component_id"
    )
      //.d-flex.align-items-center
      component.icon-sm(v-if="connector_icon", :is="connector_icon")
      div(v-else-if="next_block_id") {{ next_block_id }}
      plus-circle-icon.icon-sm(v-else)
        //chevron-right-icon.ml-1.icon-sm
    b-input-group.mb-2(v-else, :size="size")
      b-form-input.bg-white(:placeholder="placeholder", :value="inputValue", readonly, @click.native="openPopover")
      b-input-group-append
        b-button(:variant="variant", :id="component_id")
          .d-flex.align-items-center
            div(v-if="type === 'web_url'")
              span(style="min-height:24px;")
                globe-icon.icon-md
            div(v-else)
              span(v-if="next_block_id") {{ next_block_id }}
              span(v-else, style="min-height:24px;")
                plus-circle-icon.icon-sm
            chevron-right-icon.ml-1.icon-sm
    b-tooltip(:target="component_id", placement="top", triggers="hover", boundary="window")
      .d-flex.align-items-center(v-if="loading && loading_types")
        span Cargando...
        b-spinner.ml-2(small, variant="light")
      div(v-else, v-html="tooltip_content" )
    b-popover(:target="component_id", placement="top", triggers="click", boundary="window")
      template(slot="title")
        .d-flex.align-items-center.justify-content-between
          b-form-group.mb-0(label="Tipo:", label-size="sm", label-cols="auto" )
            b-form-select.ml-1.w-auto(:value="type_connector",  size="sm", :disabled="!editable", @change="updateType")
              template(slot="first")
                option(:value="null", disabled) -- Tipo --
              option(v-for="(c_type, index) in connectorTypes", :key="index", :value="c_type.value") {{c_type.title}}
          b-spinner.ml-1(small, variant="primary", v-if="loading")
          x-icon.icon-sm.pointer(@click="closePopover")
      div(v-if="type === 'web_url'")
        b-form-group.mb-0(label-size="sm", label-class="text-secondary", label="Ingresa la URL de destino:")
          b-form-textarea.mb-2(no-resize, rows="2", max-rows="6", v-model="urlInput", trim)
        b-form-group(label-cols="auto", label-class="text-secondary py-0", label="Es extensión:" )
          b-form-checkbox.mb-1(switch, :checked="is_extension", @change="$emit('change', {attribute: 'is_extension', value: $event})") {{is_extension ? 'Sí' : 'No'}}
      div(v-if="type === 'pass_info'")
        b-form-group.mb-1(label-size="sm", label-class="text-secondary", label="Variable:")
          treeselect(:options="parsed_attributes", placeholder="- Seleccionar variable -", :value="user_attribute_id", @input="$emit('change', {attribute: 'user_attribute_id', value: $event})", :clearable="false", v-bind="treeselect_options")
        b-form-group.mb-0(label-size="sm", label-class="text-secondary", label="Valor a guardar:")
          b-form-textarea.mb-2(no-resize, rows="2", max-rows="6", :value="data", trim, @input="$emit('change:delay', {attribute: 'data', value: $event})")
      div.mb-3(v-if="type === 'web_view'")
        b-form-group.mb-1(label-size="sm", label-class="text-secondary", label="Tipo de vista" )
          b-form-radio-group(v-model="webViewData.view_type", @change="webViewData.view_id = null; updateViewData()")
            b-form-radio(value="normal") Normal
            b-form-radio(value="custom") Custom
        b-form-group.mb-1(label-size="sm", label-class="text-secondary", label="Vista" )
          treeselect(:options="parsedViews", placeholder="- Seleccionar vista -", v-model="webViewData.view_id", @input="updateViewData", :clearable="false", v-bind="treeselect_options")
        b-form-group.mb-0(label-size="sm", label-class="text-secondary", label="Parámetros:")
          b-form-textarea.mb-2(no-resize, rows="2", max-rows="6", v-model="webViewData.dynamic", trim, @input="$emit('change:delay', {attribute: 'data', value: JSON.stringify(webViewData)})")
        b-form-group.mb-1(label-size="sm", label-class="text-secondary", label="Flujo" )
          treeselect(:options="parsedFlows", placeholder="- Seleccionar flujo -", v-model="webViewData.flow_id", @input="getFlow($event, true); updateViewData()", :clearable="false", v-bind="treeselect_options")
        b-form-group(label-size="sm", label-class="text-secondary", label="Bloque")
          treeselect(:options="parsedBlocks", placeholder="- Seleccionar bloque -", v-model="webViewData.next_block_id", @input="updateViewData", :clearable="false", :disabled="!this.importantOnly && !blocks.length", v-bind="treeselect_options")
      div.mb-3(v-show="has_flow_and_block")
        div(v-if="!readOnly")
          b-form-group.mb-1(label-size="sm", label-class="text-secondary", label="Flujo", v-if="!importantOnly" )
            treeselect(:options="parsedFlows", placeholder="- Seleccionar flujo -", v-model="selectedFlow", @input="flowSelected", :clearable="false", v-bind="treeselect_options")
          b-form-group(label-size="sm", label-class="text-secondary", label="Bloque")
            treeselect(:options="parsedBlocks", placeholder="- Seleccionar bloque -", v-model="selectedBlock", @input="blockSelected", :clearable="false", :disabled="!this.importantOnly && !blocks.length", v-bind="treeselect_options")
        div(v-else-if="!importantOnly")
          hr(v-if="!readOnly")
          p.mb-2.text-uppercase.text-sm Se conecta a
          b-row
            b-col(cols="6")
              p.mb-1.text-secondary.text-sm Flujo:
              p.mb-0 {{ selectedFlow }}. {{ selectedFlowName }}
            b-col(cols="6")
              p.mb-1.text-secondary.text-sm Bloque:
              p.mb-0 {{ selectedBlock }}. {{ selectedBlockName }}
      b-button.text-danger.mb-2(variant="link", block, v-if="clearable && selectedBlock" @click="removeConnection") Quitar conexión
      .d-flex.align-items-center.justify-content-between
        b-button.mr-1(size="sm", :variant="isSameConnection ? 'light' : 'primary'", block, @click="changeBlock", :disabled="!selectedBlock") Ver Bloque
        b-button.mb-2(size="sm", :variant="isSameConnection ? 'light' : 'primary'", block, @click="saveBlockConnection", :disabled="saveDisabled") {{ isSameConnection ? 'Cerrar' : 'Guardar' }}
</template>

<script>
import uuid from '@/helpers/uuid-generator'
import { createNamespacedHelpers, mapActions } from 'vuex'
import treeselect_options from '@/data/treeselect-options'
import { EventBus } from '../helpers/eventBus'

const flowController = createNamespacedHelpers('flow')
const accountController = createNamespacedHelpers('account')

export default {
  data () {
    return {
      connectorTypes: [
        { title: 'bloque', value: 'postback' },
        { title: 'Conectar bloque', value: 'payload' },
        { title: 'Botón URL', value: 'web_url' },
        { title: 'Solicitar ayuda', value: 'help_me_button' },
        { title: 'Guardar datos', value: 'pass_info' },
        { title: 'Webview', value: 'web_view' }
      ],
      component_id: '',
      blocks: [],
      viewsBlocks: [],
      treeselect_options,
      selectedFlow: null,
      selectedBlock: null,
      selectedFlowName: '',
      selectedBlockName: '',
      showingPopover: false,
      showingTooltip: false,
      loadingFlow: false,
      loadingFlows: false,
      nextBlockName: '',
      firstLoad: true,
      flowName: '',
      urlInput: '',
      initialFlowId: '',
      importantBlocks: [],
      webViewData: {
        view_type: 'normal',
        view_id: null,
        dynamic: '',
        flow_id: null,
        next_block_id: null
      }
    }
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    flow_id: {
      default: ''
    },
    next_block_id: {
      default: ''
    },
    variant: {
      type: String,
      default: 'light'
    },
    size: {
      type: String,
      default: ''
    },
    buttonOnly: {
      type: Boolean,
      default: false
    },
    pill: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Boolean,
      default: false
    },
    type: {
      default: 'postback'
    },
    url: {
      type: String,
      default: ''
    },
    importantOnly: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    data: {
      type: String,
      default: ''
    },
    is_extension: {
      type: Boolean,
      default: false
    },
    phone: {
      type: String,
      default: ''
    },
    user_attribute_id: {
      default: null
    },
    clearable: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    ...accountController.mapGetters([
      'selectedLanguage',
      'selectedLocale',
      'selectedLanguageName',
      'loadingAttrs',
      'loadingViews'
    ]),
    ...accountController.mapState({
      user_attributes: state => state.attrs,
      views: state => state.views,
      customViews: state => state.custom_views
    }),
    ...flowController.mapState({
      flows: state => state.flows
    }),
    loading () {
      return this.loadingFlows || this.loadingFlow
    },
    parsedFlows () {
      return this.flows.filter(f => Boolean(f.name)).map(f => {return {id: f.flow_id, label: f.flow_id + '. ' + f.name}})
    },
    parsedBlocks () {
      if (this.type === 'web_view') return this.viewsBlocks
      return (this.importantOnly ? this.importantBlocks : this.blocks).filter(b => Boolean(b.name)).map(b => {return {id: b.block_id, label: b.block_id + '. ' + b.name}})
    },
    parsedViews () {
      return (this.webViewData.view_type === 'normal' ? this.views : this.customViews).map(el => {
        return { id: el.view_id, label: el.name }
      })
    },
    inputValue () {
      switch (this.type) {
        case 'web_url':
          return this.url
        default:
          if (this.loadingFlows) {
            return 'Cargando información de conexión...'
          } else if (this.isDataFilled) {
            return this.importantOnly ? `Bloque: ${this.next_block_id}. ${this.nextBlockName}` : `Conecta a Flujo: ${this.initialFlowId}. ${this.flowName} - Bloque: ${this.next_block_id}. ${this.nextBlockName}`
          } else {
            return 'Conectar con bloque'
          }
      }
    },
    isDataFilled () {
      return this.flowName && this.nextBlockName
    },
    parsed_attributes () {
      return this.user_attributes.filter(el => el.name && el.user_attribute_id).map(el => {
        return { id: el.user_attribute_id, label: el.name }
      })
    },
    placeholder () {
      switch (this.type) {
        case 'web_url':
          return 'Dirección web'
        default:
          return 'Conector de bloque'
      }
    },
    popover_title () {
      switch (this.type) {
        case 'web_url':
          return 'Conectar a página web'
        default:
          return 'Conectar a bloque'
      }
    },
    saveDisabled () {
      switch (this.type) {
        case 'web_url':
          return false
        default:
          return this.loadingFlow || !this.selectedBlock
      }
    },
    isSameConnection () {
      switch (this.type) {
        case 'web_url':
          return this.url === this.urlInput
        case 'web_view':
          if (this.webViewData.next_block_id && this.parsed_web_view_data.next_block_id) {
            return this.webViewData.next_block_id === this.parsed_web_view_data.next_block_id
          }

          return false
        default:
          return (this.next_block_id === this.selectedBlock)
      }
    },
    type_connector () {
      const exist = this.connectorTypes.find(c => c.value === this.type)

      return exist ? this.type : 'postback'
    },
    loading_types () {
      if (this.$route.params.block_id && this.next_block_id === parseInt(this.$route.params.block_id)) return false

      return !['web_url', 'web_view'].includes(this.type)
    },
    has_flow_and_block () {
      switch (this.type) {
        case 'web_url':
        case 'web_view':
          return false
        default:
          return true
      }
    },
    tooltip_content () {
      if (!this.isDataFilled && this.loading_types) return 'Conectar con bloque'

      let info = ''

      switch (this.type) {
        case 'postback':
        case 'payload':
        case 'pass_info':
        case 'help_me_button':
          if (this.type === 'pass_info') {
            info = 'Guardar datos</br>'
          } else if (this.type === 'help_me_button') {
            info = 'Solicitar ayuda</br>'
          }

          if (this.next_block_id === parseInt(this.$route.params.block_id)) {
            info += 'Bloque actual'
          } else {
            info += `Flujo ${this.initialFlowId} - ${this.flowName}</br>`
            info += `Bloque ${this.next_block_id} - ${this.nextBlockName}`
          }
          break
        case 'web_view':
          info = 'Vista web'
          if (this.parsed_web_view_data) {
            if (this.parsed_web_view_data.view_type) info += `<br>Tipo: ${this.parsed_web_view_data.view_type}`
            if (this.parsed_web_view_data.flow_id) info += `<br>Flujo: ${this.parsed_web_view_data.flow_id}`
            if (this.parsed_web_view_data.next_block_id) info += `<br>Bloque: ${this.parsed_web_view_data.next_block_id}`
          }
          break
        case 'web_url':
          info = 'Botón web</br>'
          if (this.url) info += `URL: ${this.url}`
          break
        case 'login':
          info = 'Login</br>'
          if (this.url) info += `URL: ${this.url}</br>`
          if (this.next_block_id === parseInt(this.$route.params.block_id)) {
            info += 'Bloque actual'
          } else {
            info += `Flujo ${this.initialFlowId} - ${this.flowName}</br>`
            info += `Bloque ${this.next_block_id} - ${this.nextBlockName}`
          }
          break
        case 'logout':
          info = 'Logout'
          break
        case 'call':
          info = 'Llamar a número'
          if (this.phone) info += `<br>Tel: ${this.phone}`
          break
        default:
          if (this.next_block_id === parseInt(this.$route.params.block_id)) {
            info += 'Bloque actual'
          } else {
            info += `Flujo ${this.initialFlowId} - ${this.flowName}</br>`
            info += `Bloque ${this.next_block_id} - ${this.nextBlockName}`
          }
          break
      }
      return info
    },
    connector_icon () {
      switch (this.type) {
        case 'web_url':
          return 'globe-icon'
        case 'help_me_button':
          return 'flag-icon'
        case 'pass_info':
          return 'download-cloud-icon'
        case 'web_view':
          return 'monitor-icon'
        case 'login':
          return 'log-in-icon'
        case 'logout':
          return 'log-out-icon'
        case 'call':
          return 'phone-icon'
        case 'postback':
          return false
        default:
          return this.$route.params.block_id && this.next_block_id === parseInt(this.$route.params.block_id) ? 'rotate-cw-icon' : false
      }
    },
    parsed_web_view_data () {
      try {
        return JSON.parse(this.data)
      } catch (e) {
        return false
      }
    }
  },
  methods: {
    ...mapActions([
      'account/attributes',
      'account/views',
      'flow/all',
      'flow/get',
      'flow/allQueue',
      'block/get',
      'account/importantBlocks'
    ]),
    getUserAttributes () {
      if (this.user_attributes.length || this.loadingAttrs) return

      const self = this

      this['account/attributes']({
        account_id: self.$route.params.account_id,
        callback: res => {
          if (res.error) return self.$message.warning(res.error)
        }
      })
    },
    getAccountViews () {
      if (this.parsedViews.length || this.loadingViews) return

      const self = this

      this['account/views']({ account_id: self.$route.params.account_id })
    },
    getFlows () {
      const self = this
      this.loadingFlows = true

      this['flow/allQueue']({
        account_id: self.$route.params.account_id,
        callback: async (res) => {
          if (res.error) return self.$message.warning(res.error)

          if (!self.initialFlowId && self.next_block_id) {
            try {
              const block = await self.getBlock(self.next_block_id)

              if (block && block.flow_id) {
                this.initialFlowId = block.flow_id

                self.flowSelected(block.flow_id)
              }
            } catch (e) {
              self.$message.warning('Error obteniendo información de conector.')
            }
          } else {
            self.flowSelected(self.initialFlowId)
          }

          self.loadingFlows = false
        }
      })
    },
    getFlow (flowId, webView = false) {
      const self = this
      this.loadingFlow = true

      this['flow/get']({
        account_id: self.$route.params.account_id,
        flow_id: flowId,
        callback: res => {
          self.loadingFlow = false

          if (res.error) return self.$message.warning(res.error)
          if (webView) {
            this.viewsBlocks = res.resource.Blocks.map(el => {
              return { id: el.block_id, label: `${el.block_id} - ${el.name}` }
            })

            return this.viewsBlocks
          }

          self.blocks = res.resource.Blocks.slice()
          self.blockSelected(self.next_block_id)
        }
      })
    },
    async getBlock (blockId) {
      const self = this

      return new Promise((resolve, reject) => {
        this['block/get']({
          account_id: self.$route.params.account_id,
          block_id: blockId,
          params: {
            language_id: self.selectedLanguage
          },
          callback: res => {
            if (res.error) return reject(new Error(res.error))

            resolve(res.resource)
          }
        })
      })
    },
    getImportantBlocks (blockId) {
      const self = this

      this['account/importantBlocks']({
        account_id: self.$route.params.account_id,
        params: { language_id: self.selectedLanguage },
        callback: res => {
          if (res.error) return this.$message.warning(res.error)

          this.importantBlocks = res.resource

          this.blockSelected(this.next_block_id)
        }
      })
    },
    flowSelected (flowId) {
      if (Boolean(this.buttonOnly) && !this.showingPopover && !this.showingTooltip && this.isDataFilled) return

      this.blockSelected(0)

      const selectedFlow = this.flows.find(f => f.flow_id === flowId)

      if (selectedFlow) {
        this.selectedFlow = flowId
        this.selectedFlowName = selectedFlow.name

        if (this.initialFlowId === flowId) this.flowName = selectedFlow.name

        this.getFlow(flowId)

        return true
      } else {
        this.selectedFlow = null
        this.selectedFlowName = ''
        this.flowName = ''

        return false
      }
    },
    async blockSelected (blockId) {
      const selectedBlock = (this.importantOnly ? this.importantBlocks : this.blocks).find(b => b.block_id === blockId)

      if (selectedBlock) {
        this.selectedBlock = blockId
        this.selectedBlockName = selectedBlock.name

        if (this.next_block_id === this.selectedBlock) {
          this.nextBlockName = selectedBlock.name
        }

        if (this.importantOnly) {
          try {
            const block = await this.getBlock(blockId)
            this.initialFlowId = block.flow_id
          } catch (e) {
            this.$message.warning('No pudimos obtener información sobre el conector, por favor verifica tu conexión a internet')
          }
        }

        return true
      } else {
        this.selectedBlock = null
        this.selectedBlockName = ''
        this.nextBlockName = ''

        return false
      }
    },
    closePopover () {
      this.$root.$emit('bv::hide::popover', this.component_id)
    },
    openPopover () {
      try {
        document.getElementById(this.component_id).click()
      } catch (e) {
        this.$root.$emit('bv::show::popover', this.component_id)
      }
    },
    updateType (newType) {
      this.$emit('change:type', newType)
    },
    updateViewData () {
      this.$emit('change', {
        attribute: 'data',
        value: JSON.stringify(this.webViewData)
      })
    },
    async openBlockInOtherPage() {
      const regex = /flows/
      const currentRoute = this.$router.history.current.fullPath
      const params = {
        flow_id: this.selectedFlow,
        block_id: this.selectedBlock
      }
      let url = ''

      if (regex.test(currentRoute)) {
        url = this.$router.resolve({ params }).href
      } else {
        url = this.$router.resolve({ name: 'Block', params }).href
      }

      window.open(url, '_blank')

      return url
    },
    async changeBlock() {
      if (this.selectedFlow === parseInt(this.$route.params.flow_id)) {
        return this.openBlock(this.selectedBlock)
      } else {
        return await this.openBlockInOtherPage()
      }
    },
    openBlock(blockId) {
      if (parseInt(this.$route.params.block_id) === blockId) return

      return this.$router.push({ params: { block_id: blockId } }).catch(() => {})
    },
    saveBlockConnection () {
      if (!this.isSameConnection) {
        switch (this.type) {
          case 'web_url':
            this.$emit('change', {
              attribute: 'url',
              value: this.urlInput
            })
            break
          case 'web_view':
            this.updateViewData()
            break
          case 'postback':
          case 'quick_reply':
            this.$emit('change', {
              flow_id: this.selectedFlow,
              next_block_id: this.selectedBlock
            })
            break
          default:
            this.$emit('change', {
              attribute: 'next_block_id',
              value: this.selectedBlock
            })
            break
        }
      }

      this.closePopover()
    },
    removeConnection () {
      this.selectedBlock = this.selectedFlow = null

      this.$emit('change', {
        flow_id: null,
        next_block_id: null
      })
    },
    setInitialValues () {
      this.urlInput = this.url

      if (this.type === 'web_view' && this.parsed_web_view_data) {
        this.webViewData = Object.assign(this.webViewData, this.parsed_web_view_data)

        if (this.webViewData.flow_id) this.getFlow(this.webViewData.flow_id, true)
      }

      this.flowSelected(this.initialFlowId)
    }
  },
  created () {
    this.component_id = uuid('bc_xxxxxxxxxx')
  },
  async mounted () {
    EventBus.$on('connection:change', async (data) => {
      if (data.connector.flow_id) {
        return await this.flowSelected(data.connector.flow_id)
      }

      await this.blockSelected(data.connector.next_block_id)
    })
    this.getUserAttributes()
    this.getAccountViews()
    this.initialFlowId = this.flow_id

    if (this.importantOnly) {
      if (!this.initialFlowId && this.next_block_id) {
        try {
          const block = await this.getBlock(this.next_block_id)

          this.initialFlowId = block.flow_id
        } catch (e) {
          this.$message.warning('No pudimos obtener información sobre el conector, por favor verifica tu conexión a internet')
        }
      } else {
        this.flowSelected(this.initialFlowId)
      }
    }

    this.$root.$on('bv::popover::show', bvEventObj => {
      this.$root.$emit('bv::hide::popover')
      this.$root.$emit('bv::hide::tooltip')

      if (bvEventObj.target.id === this.component_id) {
        this.showingPopover = true

        if (!this.isDataFilled) this.importantOnly ? this.getImportantBlocks() : this.getFlows()
      }
    })

    this.$root.$on('bv::popover::hide', bvEventObj => {
      if (bvEventObj.target.id === this.component_id) {
        this.showingPopover = false

        if (!this.isDataFilled) this.importantOnly ? this.getImportantBlocks() : this.getFlows()
      }
    })

    this.$root.$on('bv::tooltip::show', bvEventObj => {
      if (bvEventObj.target.id === this.component_id) {
        this.showingTooltip = true

        if (this.showingPopover) bvEventObj.preventDefault()
        else if (!this.isDataFilled) this.importantOnly ? this.getImportantBlocks() : this.getFlows()
      }
    })

    this.$root.$on('bv::tooltip::hide', bvEventObj => {
      if (bvEventObj.target.id === this.component_id) this.showingTooltip = false
    })

    if (!this.buttonOnly) {
      if (!this.isDataFilled) this.importantOnly ? this.getImportantBlocks() : this.getFlows()
    }

    this.setInitialValues()
  },
  watch: {
    flows () {
      this.flowSelected(this.initialFlowId)
    },
    flow_id (newValue) {
      this.flowSelected(newValue)
    },
    next_block_id (newValue) {
      this.blockSelected(newValue)
    },
  }
}
</script>

<style lang="scss">
  .pill {
    border-radius: 50rem !important;
  }
  .tooltip-inner {
    max-width: 300px !important;
  }
</style>
